import { ListItem, Stack } from '@mui/material';
import { DocumentItem } from '../DocumentItem';
import { useDictionary, useIsDesktop } from 'Hooks';
import { DocumentsSortButton } from '../DocumentsSortButton';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import { NoResults2, PaginationResult2 } from 'Components';
import { DocumentsFilterTags } from '../DocumentsFilterTags';
import { IDocument } from 'API';
import { DocumentsOrder } from '../DocumentsMain';

interface IDocumentList {
  documents: IDocument[];
  subjects: string[];
  paginationLimit: number;
  order: DocumentsOrder;
  switchOrder: () => void;
  selectedSubjects: string[];
  setSelectedSubjects: Dispatch<SetStateAction<string[]>>;
  resetFilters: () => void;
  clearSelectedSubjects: () => void;
}

export const DocumentList = ({
  documents,
  subjects,
  paginationLimit,
  order,
  switchOrder,
  selectedSubjects,
  setSelectedSubjects,
  resetFilters,
  clearSelectedSubjects,
}: IDocumentList) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);
  const [pagination, setPagination] = useState(true);

  useEffect(() => {
    if (documents.length < paginationLimit) {
      setPagination(false);
    } else {
      setPagination(true);
    }
  }, [documents.length, paginationLimit]);

  const paginatedDocuments = useMemo(() => {
    if (pagination) return documents?.slice(0, paginationLimit);
    return documents;
  }, [documents, pagination, paginationLimit]);

  if (!paginatedDocuments.length) return <NoResults2 />;

  return (
    <Stack gap={isDesktop ? '48px' : '32px'}>
      <Stack gap={isDesktop ? '24px' : '20px'}>
        <DocumentsFilterTags
          reset={resetFilters}
          clearSelectedSubjects={clearSelectedSubjects}
          selectedSubjects={selectedSubjects}
          setSelectedSubjects={setSelectedSubjects}
          subjects={subjects}
        />
        <DocumentsSortButton
          foundDocuments={paginatedDocuments.length}
          sort={switchOrder}
          sortingOrder={order}
        />
        <Stack
          component={'ul'}
          padding={0}
          margin={0}
          gap={isDesktop ? '24px' : '20px'}
        >
          {paginatedDocuments.map((document, index) => (
            <ListItem
              key={index}
              sx={{
                padding: '0',
                width: isDesktop ? undefined : '91%',
                margin: isDesktop ? undefined : '0 auto',
              }}
            >
              <DocumentItem document={document} />
            </ListItem>
          ))}
        </Stack>
      </Stack>
      {documents.length > paginationLimit && (
        <PaginationResult2
          text={
            pagination
              ? dictionary.previousDocuments
              : dictionary.reduceDocuments
          }
          onClick={() => setPagination(!pagination)}
          isPaginated={!pagination}
        />
      )}
    </Stack>
  );
};
